<v4-custom-select
  [size]="size"
  [placeholder]="placeholder"
  [textItem]="textView"
  [showTextItem]="textView"
  [(visible)]="dropdownVisible"
>
  <div class="v4-layout-dropdown" style="padding: 0">
    <ng-container *ngIf="mode !== 'quarter'; else quarterPanel">
      <nz-range-picker
        nzInline
        [nzMode]="mode"
        [ngModel]="value"
        [nzDisabledDate]="disabledDate"
        (ngModelChange)="onDatesChange($event)"
        [nzRenderExtraFooter]="mode !== 'year' && showFooter ? footer : null"
      ></nz-range-picker>
    </ng-container>

    <ng-template #quarterPanel>
      <host-range-quarter
        [ngModel]="value"
        (ngModelChange)="onDatesChange($event)"
        [extraFooter]="footer"
      ></host-range-quarter>
    </ng-template>

    <ng-template #footer>
      <div class="range-extra-footer flex flex-row flex-wrap py-3">
        <a class="mr-2" nz-button nzType="link" *ngFor="let preset of presetRanges" (click)="onClickPreset(preset)">
          {{ "component.search." + preset.label | translate }}
        </a>
      </div>
    </ng-template>
  </div>
</v4-custom-select>
